
  import cfproxyRuntime$_90w_45enEAbfThTA4z5GydHYMnN6W4K0hL1cRaEdw2Wug from '/app/template1/providers/cfproxy.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "cfproxy",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"cfproxy"} */
    provider: "cfproxy",
    providers: {
        ['cfproxy']: { setup: cfproxyRuntime$_90w_45enEAbfThTA4z5GydHYMnN6W4K0hL1cRaEdw2Wug, defaults: {"domains":["ur2h9smi.turpal.com","tw028jd0.turpal.com"],"defaultFormat":"webp","excludeExtensions":["svg","gif","ico","avif"]} }
    }
  }
